module.exports = __webpack_public_path__ + "static/media/ref.65aa2de4.png";